// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"60":"c6a72f3d","706":"8a7211f0","768":"556b4b16","885":"f06cf14b"}[chunkId] + ".js";
};